const components = {
    BLANK_LINK: "#!",
};

export default components;